import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import routes, { nonNavRoutes } from './routes'
import { useHandleUtils } from 'services/useHandleUtils';

const ConditionalRoute = ({ component: Component, condition, ...rest }) => (
  <Route
    exact
    {...rest}
    render={(props) =>
      condition ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: '/signin', state: { from: props.location } }}
        />
      )
    }
  />
)

function Routes() {
  const { getMenuList } = useHandleUtils()

  return (
    <Switch>
      {routes.map(({ component: Component, path, exact, menu }) => (
        (getMenuList()?.includes(menu)) &&
        <ConditionalRoute
          key={path}
          path={path}
          exact={exact}
          component={Component}
          condition={true}
        />
      ))}

      {nonNavRoutes.map(({ component: Component, path, exact }) => (
        <Route
          key={path}
          path={path}
          exact={exact}
          component={Component}
          condition={true}
        />
      ))}
    </Switch>
  )
}

export default Routes
